<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header-class="redmfu">
            <div slot="header" v-if="thai_student==1">
              <strong v-if="thai_student==1">ข้อมูลทั่วไป (ที่อยู่ปัจจุบัน)</strong>
              <strong v-else>General Information</strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <b-row>
              <b-col sm="12">
                <b-form-group v-if="thai_student ==1 " label="คำอ่านชื่อ " label-for="basicStatic" :label-cols="2">
                  <b-form-input
                    id="current_spell_name"
                    type="text"
                    autocomplete="current_spell_name"
                    v-model="current_spell_name"
                    :state="validation_spell"
                  ></b-form-input>
                  <b-form-group
                    label="ตัวอย่างเช่น กุลธิดา ให้พิมพ์คำอ่านเป็น กุน-ละ-ธิ-ดา (ใส่เว้นวรรค์ระหว่างคำ) เพื่อความถูกต้องในการขานชื่อในพิธีรับพระราชทานปริญญาบัตร"
                    :label-cols="12"></b-form-group>
                  <b-form-invalid-feedback :state="validation_spell">
                    Your Spell name must be 3-100 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_spell">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
                <b-form-group v-if="thai_student ==0 " label="Name Surname" label-for="basicStatic" :label-cols="2">
                  <b-form-input
                    id="current_spell_name"
                    type="text"
                    autocomplete="current_spell_name"
                    v-model="current_spell_name"
                    :state="validation_spell"
                  ></b-form-input>
                  <b-form-group
                    label="Please show how to pronounce your name For example, MR. DAGO TSHERING : DA-GO-SHER-RING"
                    :label-cols="12"></b-form-group>
                  <b-form-invalid-feedback :state="validation_spell">
                    Your Spell must be 3-100 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_spell">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">

                <b-form-group v-if="thai_student ==1 " label="คำอ่านนามสกุล" label-for="basicStatic" :label-cols="2">
                  <b-form-input
                    id="current_spell_surname"
                    type="text"
                    autocomplete="current_spell_surname"
                    v-model="current_spell_surname"
                    :state="validation_spell_surname"
                  ></b-form-input>
                  <b-form-group label="ตัวอย่างเช่น ขัณฑสกร ให้พิมพ์คำอ่านเป็น ขัน-ทด-สะ-กอน (ไม่เว้นวรรค)"
                                :label-cols="12"></b-form-group>
                  <b-form-invalid-feedback :state="validation_spell_surname">
                    Your Spell surname name must be 5-100 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_spell_surname">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group :label="lbl_country" :label-cols="2">
                  <v-select
                    label="COUNTRYNAME"
                    :options="countryItems"
                    v-model="select_country1"
                    @input="selectCountryOnchange"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="thai_student==1">
              <b-col sm="12">
                <div align="left"><strong><br><u>ที่อยู่ปัจจุบัน</u><br></strong></div>
              </b-col>
            </b-row>
            <b-row><br></b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group :label="lbl_tel" :label-cols="4">
                  <b-form-input
                    v-if="select_country=='TH'"
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                    maxlength=10
                    :state="validation_tel"
                  >{{ current_tel }}
                  </b-form-input>
                  <b-form-input
                    v-else
                    id="current_tel"
                    type="text"
                    autocomplete="current_tel"
                    v-model="current_tel"
                    maxlength=30
                    :state="validation_tel"
                  >{{ current_tel }}
                  </b-form-input>

                  <b-form-group v-if="select_country=='TH' && thai_student==1"
                                label="ตัวอย่าง 0936601665 (ไม่เว้นวรรค ไม่มีสัญลักษณ์)" :label-cols="12">
                  </b-form-group>
                  <b-form-invalid-feedback :state="validation_tel" v-if="select_country=='TH'">
                    Your mobilephone must be 9-10 characters long.
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="validation_tel" v-else>
                    Your mobilephone must be 10-30 characters long.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_tel">
                    Correct.
                  </b-form-valid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group :label="lbl_email" :label-cols="2">
                  <b-form-input
                    id="current_email"
                    type="email"
                    autocomplete="current_email"
                    v-model="current_email"
                    name="current_email"
                    :state="validation_email"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="validation_email">
                    Please enter a valid email address.
                  </b-form-invalid-feedback>
                  <b-form-valid-feedback :state="validation_email">
                    Correct.
                  </b-form-valid-feedback>

                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group :label="lbl_province" :label-cols="4">
                  <div v-if="select_country =='TH' ">
                    <b-form-select
                      value-field="PROVINCE_ID"
                      text-field="PROVINCENAME"
                      size="md"
                      :plain="true"
                      :options="provinceItems"
                      v-model="select_province"
                      v-on:change="selectProvinceOnchange"
                    ></b-form-select>
                  </div>
                  <div v-else>
                    <b-form-input
                      id="current_province_name"
                      type="text"
                      autocomplete="current_province_name"
                      v-model="current_province_name"
                      :state="validation_province"
                      placeholder=""
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validation_province">
                      Your province must be 1-50 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_province">
                      Correct.
                    </b-form-valid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-col sm="6">

                <b-form-group :label="lbl_district" :label-cols="2">
                  <div v-if="select_country =='TH' ">
                    <b-form-select
                      value-field="DISTRICTID"
                      text-field="DISTRICTNAME"
                      class="mb-3"
                      :plain="true"
                      :options="districtItems"
                      v-model="select_district"
                      v-on:change="selectDistrictOnchange"
                    ></b-form-select>
                  </div>
                  <div v-else>
                    <b-form-input
                      id="current_district_name"
                      type="text"
                      autocomplete="current_district_name"
                      v-model="current_district_name"
                      :state="validation_district"
                      placeholder=""
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validation_district">
                      Your district must be 1-50 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_district">
                      Correct.
                    </b-form-valid-feedback>
                  </div>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group :label="lbl_sub" :label-cols="4">
                  <div v-if="select_country =='TH' ">
                    <b-form-select
                      value-field="SUB_DISTRICTID"
                      text-field="SUB_DISTRICTNAME"
                      size="md"
                      :plain="true"
                      :options="subdistrictItems"
                      v-model="select_subdistrict"
                      v-on:change="selectSubDistrictOnchange"
                    ></b-form-select>
                  </div>
                  <div v-else>
                    <b-form-input
                      id="current_subdistrict_name"
                      type="text"
                      autocomplete="current_subdistrict_name"
                      v-model="current_subdistrict_name"
                      :state="validation_subdistrict"
                      placeholder=""
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validation_subdistrict">
                      Your subdistrict must be 1-50 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_subdistrict">
                      Correct.
                    </b-form-valid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group :label="lbl_zip" :label-cols="2">
                  <div v-if="select_country=='TH'">
                    <b-form-input
                      id="current_zipcode"
                      type="text"
                      autocomplete="current_zipcode"
                      v-model="current_zipcode"
                      maxlength="5"
                    ></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-input
                      id="current_zipcode"
                      type="text"
                      autocomplete="current_zipcode"
                      v-model="current_zipcode"
                      :state="validation_zipcode"
                      placeholder=""
                      maxlength="7"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validation_zipcode">
                      Your zipcode must be 1-7 characters long,Do not put a , or -
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_zipcode">
                      Correct.
                    </b-form-valid-feedback>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group :label="lbl_no" :label-cols="2">
              <b-form-input
                id="current_no"
                type="text"
                autocomplete="current_no"
                v-model="current_no"
                :state="validation_no"
              ></b-form-input>
              <b-form-invalid-feedback :state="validation_no" v-if="thai_student==1">
                กรอกบ้านเลขที่เท่านั้น (หมู่บ้าน อาคาร/ตึก กรอกด้านล่าง)
              </b-form-invalid-feedback>
              <b-form-invalid-feedback :state="validation_no" v-else>
                Your Number must be 1-50 characters long.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validation_no">
                Correct.
              </b-form-valid-feedback>
            </b-form-group>
            <b-form-group :label="lbl_moo" :label-cols="2" v-if="select_country=='TH'">
              <b-form-input
                id="current_moo"
                type="text"
                autocomplete="current_moo"
                v-model="current_moo"
                :state="validation_moo"
              ></b-form-input>
              <b-form-invalid-feedback :state="validation_moo">
                Your Moo must be 1-50 characters long.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validation_moo">
                Correct.
              </b-form-valid-feedback>
            </b-form-group>

            <b-form-group :label="lbl_village" :label-cols="2">
              <b-form-input
                id="current_village"
                type="text"
                autocomplete="current_village"
                v-model="current_village"
                :state="validation_village"
              ></b-form-input>
              <b-form-invalid-feedback :state="validation_village">
                Your Villa must be 1-50 characters long.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validation_village">
                Correct.
              </b-form-valid-feedback>
            </b-form-group>


            <b-form-group :label="lbl_building" :label-cols="2">
              <b-form-input
                id="current_building"
                type="text"
                autocomplete="current_building"
                v-model="current_building"
                :state="validation_build"
                placeholder=""
              ></b-form-input>
              <b-form-invalid-feedback :state="validation_build">
                Your Building must be 1-50 characters long.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validation_build">
                Correct.
              </b-form-valid-feedback>
            </b-form-group>


            <b-form-group :label="lbl_soi" :label-cols="2">
              <b-form-input
                id="current_lane"
                type="text"
                autocomplete="current_lane"
                v-model="current_lane"
                :state="validation_soi"
                placeholder=""
              ></b-form-input>
              <b-form-invalid-feedback :state="validation_soi">
                Your Soi must be 1-50 characters long.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validation_soi">
                Correct.
              </b-form-valid-feedback>
            </b-form-group>

            <!--              <div v-if="thai_student ==0 ">-->
            <b-form-group :label="lbl_road" :label-cols="2">
              <b-form-input
                id="current_road"
                type="text"
                autocomplete="current_road"
                v-model="current_road"
                :state="validation_road"
                placeholder=""
              ></b-form-input>
              <b-form-invalid-feedback :state="validation_road">
                Your Road must be 1-50 characters long.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validation_road">
                Correct.
              </b-form-valid-feedback>
            </b-form-group>

            <div slot="footer" class="text-center">

              <div slot="footer" class="text-center">
                <b-button type="submit" size="md" class="mr-2" variant="success " @click="onBack">
                  <i class="fa fa-arrow-circle-o-left"></i> Back
                </b-button>
                <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                  <i class="fa fa-dot-circle-o"></i> Submit
                </b-button>
                <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                  <i class="fa fa-ban"></i> Reset
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      selected: "",
      student: {},
      studentinfo: {},
      studentId: "",
      studentCode: "",
      dangerModal: false,
      current_erorrtxt: "",
      numEror: 0,
      thai_student: "",
      select_province: 0,
      current_province: "",
      provinceItems: [],
      select_district: 0,
      districtItems: [],
      select_subdistrict: 0,
      subdistrictItems: [],
      select_country: 'TH',
      select_country1: "",//ไทย
      current_country_name: "",
      current_country_name1: "",
      countryItems: [],
      current_thai_student: "",
      current_spell_name: "",
      current_spell_surname: "",
      current_tel: "",
      current_email: "",
      current_no: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_address: "",
      current_building: "",
      current_provinceid: "",
      current_province_name: "",
      current_district: "",
      current_district_name: "",
      current_subdistrict: "",
      current_subdistrict_name: "",
      actionUpdate: 10,
      qn_work_status: "",
      current_citizen: "",
      lbl_tel: "",
      lbl_email: "",
      lbl_country: "",
      lbl_district: "",
      lbl_sub: "",
      lbl_province: "",
      lbl_zip: "",
      lbl_no: "บ้านเลขที่",
      lbl_moo: "หมู่",
      lbl_village: "หมู่บ้าน",
      lbl_building: "อาคาร/ตึก",
      lbl_soi: "ซอย",
      lbl_road: "ถนน",


      time: 0,
      isRunning: false,

    };
  }, computed: {
    validation_email(){
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const thaiCharRegex = /[ก-ฮ]/;
      if (this.current_email=='-@gmail.com' || this.current_email=='-@lamduan.mfu.ac.th'
        || this.current_email=='-@yahoo.com' || this.current_email=='-@hotmail.com'
        || this.current_email=='-@hotmail.co.th' || this.current_email==='None'   ){
        return false;
      }else {
        if (this.current_email != null && this.current_email != '' && this.current_email != undefined) {
          if (!emailRegex.test(this.current_email)) {
            return false;
          } else if (thaiCharRegex.test(this.current_email)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    validation_tel() {
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_tel != null && this.current_tel != '' && this.current_tel != undefined) {
        if (this.select_country != 'TH') {
          // console.log("select_country==",this.select_country,"==",this.current_tel.toString().length)
          if (this.current_tel.toString().length >= 10 && this.current_tel.toString().length <= 30) {
            if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
              return false;
            } else {
              // console.log("this.validPhone() ==", this.validPhone());
              if (this.validPhone()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        } else { // TH
          if (this.current_tel.toString().length == 10) {
            if ((this.current_tel.toString().includes(substring)) || (this.current_tel.toString().includes(spacestring)) || (this.current_tel.toString().includes(zerochar))) {
              return false;
            } else {
              // console.log("this.validPhone() ==", this.validPhone());
              if (this.validPhone()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }

      } else {
        return false;
      }
    },
    validation_spell_surname() {
      var spacestring = " ";
      var substring = "-";
      // console.log("length==",this.current_spell_surname.length)
      if (this.current_spell_surname != null && this.current_spell_surname != '' && this.current_spell_surname != undefined) {
        // if (this.current_spell_surname.includes(substring)) {
        if (this.current_spell_surname.length >= 3 && this.current_spell_surname.length < 100) {
          if (!this.current_spell_surname.includes(substring)) {
            return false;
          } else {
            if ((this.current_spell_surname.length >= 3) && (this.current_spell_surname.length <= 5)) {
              if (this.current_spell_surname.includes(spacestring)) {
                return false;
              } else {
                return true;
              }
            } else {
              if (this.current_spell_surname.includes(spacestring)) {
                return false;
              } else {
                if (this.current_spell_surname.includes(substring)) {
                  return true;
                }
              }
            }
          }


        } else {
          return false;
        }
      } else {
        return false;
      }

      /* var spacestring = " ";
       if (this.current_spell_surname != null) {
         if (this.current_spell_surname.length >= 3 && this.current_spell_surname.length < 100) {
           if ((this.current_spell_surname.length >= 3) && (this.current_spell_surname.length <= 5)) {
             return true;
           } else {
             if (this.current_spell_surname.includes(spacestring)) {
               return false;
             } else {
               return true;
             }
           }
         }
       } else {
         return false;
       } */
    },
    validation_spell() {
      var spacestring = " ";
      var substring = "-";
      // console.log("length==",this.current_spell_name.length)
      if (this.current_spell_name != null && this.current_spell_name != '' && this.current_spell_name != undefined) {
        // if (this.current_spell_name.includes(substring)) {
        if (this.current_spell_name.length >= 3 && this.current_spell_name.length < 300) {

          if (!this.current_spell_name.includes(substring)) {
            return false;
          } else {

            if ((this.current_spell_name.length >= 3) && (this.current_spell_name.length <= 5)) {
              if (this.current_spell_name.includes(spacestring)) {
                return false;
              } else {
                return true;
              }
            } else {
              if (this.current_spell_name.includes(spacestring)) {
                return false;
              } else {
                if (this.current_spell_name.includes(substring)) {
                  return true;
                }
              }
            }
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validation_province() {
      if (this.current_province_name != null && this.current_province_name != '' && this.current_province_name != undefined) {
        return this.current_province_name.length >= 1 && this.current_province_name.length < 50
      } else {
        return false;
      }
    },
    validation_district() {
      // console.log("validation_district==",this.current_district.length)
      if (this.current_district_name != null && this.current_district_name != '' && this.current_district_name != undefined) {
        return this.current_district_name.length >= 1 && this.current_district_name.length < 50
      } else {
        return false;
      }
    },
    validation_subdistrict() {
      if (this.current_subdistrict_name != null && this.current_subdistrict_name != '' && this.current_subdistrict_name != undefined) {
        return this.current_subdistrict_name.length >= 1 && this.current_subdistrict_name.length < 50
      } else {
        return false;
      }
    },
    validation_zipcode() {
      // console.log("current_zipcode==",this.current_zipcode.toString().length)
      if (this.current_zipcode != null && this.current_zipcode != '' && this.current_zipcode != undefined) {
        var substring = "-";
        if (this.current_zipcode.toString().length >= 1 && this.current_zipcode.toString().length <= 7) {
          if (this.current_zipcode.toString().includes(substring)) {
            // console.log("มี-")
            return false;
          } else {
            // console.log("ไม่มี-")
            if ((this.current_zipcode <= 9999999) && (this.current_zipcode >= 1)) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          // console.log("f")
          return false;
        }
      } else {
        return false;
      }
    },
    isNumber(n) {
      if ((n != null) && (n != '')) {
        if ((n > 999) || (n <= 9999999)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validation_no() {
      var bracket_open = "(";
      var bracket_close = ")";
      var square = "#";
      var star = "*";
      if (this.current_no != null && this.current_no != "" && this.current_no != undefined) {
        if ((this.current_no > 1) || (this.current_no < 9999999)) {
          return true;
        } else if (this.current_no == "-") {
          return true;
        } else {
          if (this.current_no.toString().length == 0) {
            return false;
          } else {
            if (this.current_no.includes(bracket_open) || this.current_no.includes(bracket_close)
              || this.current_no.includes(square) || this.current_no.includes(star)) {
              return false;
            } else if (this.current_no.includes('/') || this.current_no.includes('-')) {
              return true;
            }

          }
        }
      } else {
        return false;
      }

    },
    validation_village() {
      if (this.current_village != null && this.current_village != '' && this.current_village != undefined) {
        return this.current_village.length >= 1 && this.current_village.length < 50
      } else {
        return false;
      }
    },
    validation_build() {
      if (this.current_building != null && this.current_building != '' && this.current_building != undefined) {
        return this.current_building.length >= 1 && this.current_building.length < 50
      } else {
        return false;
      }
    },
    validation_road() {
      if (this.current_road != null && this.current_road != '' && this.current_road != undefined) {
        return this.current_road.length >= 1 && this.current_road.length < 50
      } else {
        return false;
      }
    },
    validation_soi() {
      if (this.current_lane != null && this.current_lane != '' && this.current_lane != undefined) {
        return this.current_lane.length >= 1 && this.current_lane.length < 50
      } else {
        return false;
      }
    },
    validation_moo() {
      if (this.current_moo != null && this.current_moo != '' && this.current_moo != undefined) {
        return this.current_moo.length >= 1 && this.current_moo.length < 50
      } else {
        return false;
      }
    },
    validation_add() {
      if (this.current_address != null && this.current_address != '' && this.current_address != undefined) {
        return this.current_address.length >= 10 && this.current_address.length < 500
      } else {
        return false;
      }
    },
  },
  components: {
    vSelect
  }
  ,
  methods: {

    onBack() {
      this.$router.push("/dashboard");
    },
    validEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const thaiCharRegex = /[ก-ฮ]/;
      if (email=='-@gmail.com' || email=='-@lamduan.mfu.ac.th'
        || email=='-@yahoo.com' || email=='-@hotmail.com'
        || email=='-@hotmail.co.th'|| email=='None'  ){
        return false;
      }else {
        if (email != null && email != '' && email != undefined) {
          if (!emailRegex.test(email)) {
            return false;
          } else if (thaiCharRegex.test(email)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    validPhone() {
      // var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      // var phoneno =/^\d{10}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;


      if (this.current_tel.match(phoneno10) || this.current_tel.match(phoneno11) || this.current_tel.match(phoneno12) || this.current_tel.match(phoneno13)|| this.current_tel.match(phoneno14)
        || this.current_tel.match(phoneno15) || this.current_tel.match(phoneno16) || this.current_tel.match(phoneno17) || this.current_tel.match(phoneno18)
        || this.current_tel.match(phoneno19) || this.current_tel.match(phoneno20) || this.current_tel.match(phoneno21) || this.current_tel.match(phoneno22)
        || this.current_tel.match(phoneno23) || this.current_tel.match(phoneno24) || this.current_tel.match(phoneno25) || this.current_tel.match(phoneno26)
        || this.current_tel.match(phoneno27) || this.current_tel.match(phoneno28) || this.current_tel.match(phoneno29) || this.current_tel.match(phoneno30)) {
        // console.log("--------true---------",this.current_tel);
        return true;
      } else {
        // console.log("--------false---------",this.current_tel);
        return false;
      }
    },

    getStudentID() {
      // console.log("getStudentID==", this.$store.state.user);
      this.thai_student = this.$store.state.user.thaistudent;
      this.studentId = this.$store.state.user.studentid;
      this.sex = this.$store.state.user.sex;
      this.getCountry(this.thai_student);
      this.getProvince(this.thai_student);
    },
    setStudent: function () {
      var student = {};
      student.univ_id = "02400";
      student.qn_year = 2567;
      student.std_id = this.$store.state.user.studentid;
      student.current_citizen = this.$store.state.user.citizen;
      student.current_tel = this.current_tel;
      student.current_email = this.current_email;
      student.current_thai_student = this.thai_student;
      student.current_country = this.select_country;
      student.current_spell_name = "";
      student.current_spell_surname = "";
      if (this.thai_student == 1) {
        student.current_spell_name = this.current_spell_name;
        student.current_spell_surname = this.current_spell_surname;
      } else {
        student.current_spell_name = this.current_spell_name;
        student.current_spell_surname = "";
      }
      student.current_zipcode = this.current_zipcode;
      student.current_no = this.current_no;
      student.current_moo = this.current_moo;
      //.replaceAll( "'", "`");
      // student.current_village = this.current_village;
      student.current_village = this.current_village
      //replaceAll( "'", "`");
      student.current_building = this.current_building
      //.replaceAll( "'", "`");
      student.current_lane = this.current_lane
      //.replaceAll( "'", "`");
      student.current_road = this.current_road
      //.replaceAll( "'", "`");
      if (this.select_country == 'TH') {
        student.current_provinceid = this.select_province;
        student.current_district = this.current_district;
        student.current_subdistrict = this.current_subdistrict;
        student.current_country_name = "THAILAND";
        student.current_province_name = this.current_province_name;
        student.current_district_name = this.current_district_name;
        student.current_subdistrict_name = this.current_subdistrict_name;
      } else {

        student.current_moo = "";
        student.current_provinceid = "";
        student.current_district = "";
        student.current_subdistrict = "";
        student.current_country_name = this.current_country_name;
        student.current_province_name = this.current_province_name;
        student.current_district_name = this.current_district_name;
        student.current_subdistrict_name = this.current_subdistrict_name;

        // student.current_zipcode = "";
        // student.current_no = "";
        // student.current_moo = "";
        // student.current_village = "";
        // student.current_building = "";
        // student.current_lane = "";
        // student.current_road = "";
      }
      // console.log("setStudent==", student);
      return student;
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("res== ",res);
          if (res.data.data.length == 0) {
            this.actionUpdate = 0;
            if (this.thai_student == 1) {
              this.$router.push("/con");
            }
          } else if (res.data.data.length == 1) {
            // console.log("res== ",res);
            this.actionUpdate = 1;
            var currentSt = res.data.data[0]; // เก่า
            // console.log("thai_student== ", this.thai_student);
            if ((this.thai_student == 1) && (currentSt.CONSENT == '' || currentSt.CONSENT == null || currentSt.CONSENT == undefined)) {
              this.$router.push("/con");
            }
            this.student.qn_year = currentSt.QN_YEAR
            this.qn_year = currentSt.QN_YEAR
            this.student.thai_student = currentSt.THAI_STUDENT;
            this.thai_student = currentSt.THAI_STUDENT;
            this.current_citizen = currentSt.CITIZENID;
            this.qn_work_status = currentSt.QN_WORK_STATUS;
            this.student.current_spell_name = currentSt.CURRENT_SPELL_NAME
            this.current_spell_name = currentSt.CURRENT_SPELL_NAME
            this.student.current_spell_surname = currentSt.CURRENT_SPELL_SURNAME
            this.current_spell_surname = currentSt.CURRENT_SPELL_SURNAME
            this.student.current_tel = currentSt.CURRENT_TEL;
            this.current_tel = currentSt.CURRENT_TEL;
            this.student.select_country = currentSt.CURRENT_COUNTRY;
            this.current_country = currentSt.CURRENT_COUNTRY;
            this.student.current_email = currentSt.CURRENT_EMAIL;
            this.current_email = currentSt.CURRENT_EMAIL;
            this.student.current_no = currentSt.CURRENT_NO;
            this.current_no = currentSt.CURRENT_NO;
            this.student.current_village = currentSt.CURRENT_VILLAGE;
            this.current_village = currentSt.CURRENT_VILLAGE;
            this.student.current_building = currentSt.CURRENT_BUILDING;
            this.current_building = currentSt.CURRENT_BUILDING;
            this.student.current_moo = currentSt.CURRENT_MOO;
            this.current_moo = currentSt.CURRENT_MOO;
            this.student.current_lane = currentSt.CURRENT_LANE;
            this.current_lane = currentSt.CURRENT_LANE;
            this.student.current_road = currentSt.CURRENT_ROAD;
            this.current_road = currentSt.CURRENT_ROAD;
            this.student.current_zipcode = currentSt.CURRENT_ZIPCODE;
            this.current_zipcode = currentSt.CURRENT_ZIPCODE;
            this.student.current_spell_name = currentSt.CURRENT_SPELL_NAME;
            this.current_spell_name = currentSt.CURRENT_SPELL_NAME;
            this.student.current_spell_surname = currentSt.CURRENT_SPELL_SURNAME;
            this.current_spell_surname = currentSt.CURRENT_SPELL_SURNAME;
            this.student.current_provinceid = currentSt.CURRENT_PROVINCEID;
            this.current_provinceid = currentSt.CURRENT_PROVINCEID;
            this.student.current_district = currentSt.CURRENT_DISTRICT;
            this.current_district = currentSt.CURRENT_DISTRICT;
            this.student.current_subdistrict = currentSt.CURRENT_SUBDISTRICT;
            this.current_subdistrict = currentSt.CURRENT_SUBDISTRICT;
            this.student.current_country = currentSt.CURRENT_COUNTRY;
            this.current_country = currentSt.CURRENT_COUNTRY;
            this.select_country = currentSt.CURRENT_COUNTRY;
            this.select_country1 = currentSt.CURRENT_COUNTRY_NAME;
            this.getCountry(this.thai_student);
            this.student.current_country_name = currentSt.CURRENT_COUNTRY_NAME;
            this.current_country_name = currentSt.CURRENT_COUNTRY_NAME;
            if (currentSt.CURRENT_COUNTRY == 'TH') {
              this.getProvince(this.thai_student);
              this.select_province = currentSt.CURRENT_PROVINCEID;
              this.select_district = currentSt.CURRENT_DISTRICT;
              this.onloadDistrictById(this.select_province);
              this.select_subdistrict = currentSt.CURRENT_SUBDISTRICT;
              this.onloadSubDistrictById(this.select_district);
            } else {
              this.current_province_name = currentSt.CURRENT_PROVINCE_NAME;
              this.current_district_name = currentSt.CURRENT_DISTRICT_NAME;
              this.current_subdistrict_name = currentSt.CURRENT_SUBDISTRICT_NAME;
              // this.current_address = currentSt.CURRENT_ADDRESS;
            }
          } else {
            this.actionUpdate = 10;
            // console.log("actionUpdate== ", this.actionUpdate);
          }
          // console.log("student== ", this.student);
          return this.actionUpdate;
        })
        .catch(err => {
          this.actionUpdate = 10;
          // console.log("actionUpdate== ", this.actionUpdate);
          console.log("getStudentGeneral", err);
          // this.$router.push("Logout");

        });

      //  return act;
    },
    getLabelName(thai) {
      if (thai == 1) {
        this.lbl_tel = "โทรศัพท์เคลื่อนที่(ปัจจุบัน)";
        this.lbl_email = "อีเมล์";
        this.lbl_country = "อาศัยอยู่ในประเทศ";
        this.lbl_district = "อำเภอ";
        this.lbl_sub = "ตำบล";
        this.lbl_province = "จังหวัด";
        this.lbl_zip = "รหัสไปรษณีย์";
        this.lbl_no = "บ้านเลขที่";
        this.lbl_moo = "หมู่";
        this.lbl_village = "หมู่บ้าน";
        this.lbl_building = "อาคาร/ตึก";
        this.lbl_soi = "ซอย";
        this.lbl_road = "ถนน";
      } else {
        this.lbl_tel = "Mobile Phone";
        this.lbl_email = "Email";
        this.lbl_country = "Country";
        this.lbl_district = "District";
        this.lbl_sub = "SubDistrict";
        this.lbl_province = "Province";
        this.lbl_zip = "Postcode";
        this.lbl_no = "Number";
        this.lbl_moo = "Moo";
        this.lbl_village = "Villa";
        this.lbl_building = "Building";
        this.lbl_soi = "Soi";
        this.lbl_road = "Road";
      }
    },

    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";


      if (s.current_village != '' && s.current_village != null && s.current_village != undefined) {
        if (s.current_village.toString().length > 0) {
          if (s.current_village.includes(quotation1)) {
            s.current_village = s.current_village.replaceAll(quotation1, "''");
          }
          if (s.current_village.includes(quotation2)) {
            s.current_village = s.current_village.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_building != '' && s.current_building != null && s.current_building != undefined) {
        if (s.current_building.toString().length > 0) {
          if (s.current_building.includes(quotation1)) {
            s.current_building = s.current_building.replaceAll(quotation1, "''");
          }
          if (s.current_building.includes(quotation2)) {
            s.current_building = s.current_building.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_road != '' && s.current_road != null && s.current_road != undefined) {
        if (s.current_road.toString().length > 0) {
          if (s.current_road.includes(quotation1)) {
            s.current_road = s.current_road.replaceAll(quotation1, "''");
          }
          if (s.current_road.includes(quotation2)) {
            s.current_road = s.current_road.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_lane != '' && s.current_lane != null && s.current_lane != undefined) {
        if (s.current_lane.toString().length > 0) {
          if (s.current_lane.includes(quotation1)) {
            s.current_lane = s.current_lane.replaceAll(quotation1, "''");
          }
          if (s.current_lane.includes(quotation2)) {
            s.current_lane = s.current_lane.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_moo != '' && s.current_moo != null && s.current_moo != undefined) {
        if (s.current_moo.toString().length > 0) {
          if (s.current_moo.includes(quotation1)) {
            s.current_moo = s.current_moo.replaceAll(quotation1, "''");
          }
          if (s.current_moo.includes(quotation2)) {
            s.current_moo = s.current_moo.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_address != '' && s.current_address != null && s.current_address != undefined) {
        if (s.current_address.toString().length > 0) {
          if (s.current_address.includes(quotation1)) {
            s.current_address = s.current_address.replaceAll(quotation1, "''");
          }
          if (s.current_address.includes(quotation2)) {
            s.current_address = s.current_address.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_subdistrict_name != '' && s.current_subdistrict_name != null && s.current_subdistrict_name != undefined) {
        if (s.current_subdistrict_name.toString().length > 0) {
          if (s.current_subdistrict_name.includes(quotation1)) {
            s.current_subdistrict_name = s.current_subdistrict_name.replaceAll(quotation1, "''");
          }
          if (s.current_subdistrict_name.includes(quotation2)) {
            s.current_subdistrict_name = s.current_subdistrict_name.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_district_name!= '' && s.current_district_name != null && s.current_district_name != undefined) {
        if (s.current_district_name.toString().length > 0) {
          if (s.current_district_name.includes(quotation1)) {
            s.current_district_name = s.current_district_name.replaceAll(quotation1, "''");
          }
          if (s.current_district_name.includes(quotation2)) {
            s.current_district_name = s.current_district_name.replaceAll(quotation2, "''");
          }
        }
      }
     // console.log("current_province_name==",s.current_province_name)
      if (s.current_province_name!= '' && s.current_province_name != null && s.current_province_name != undefined) {
        if (s.current_province_name.toString().length > 0) {
          if (s.current_province_name.includes(quotation1)) {
            s.current_province_name = s.current_province_name.replaceAll(quotation1, "''");
          }
          if (s.current_province_name.includes(quotation2)) {
            s.current_province_name = s.current_province_name.replaceAll(quotation2, "''");
          }
        }
      }
      return s;
    },
    getErrorTxt: function (s) {
      // console.log("this.validPhone() ==", this.validPhone());
      var substringnull = " ";
      var substring = "-";
      var zerochar = "00000";
      this.current_erorrtxt = "";
      this.numEror = 0;

      var student = this.checkQuotation(s);
      // console.log("student ==", student);
      if (student.current_tel == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์" : this.current_erorrtxt + "/Mobile Phone";
      }
      if (student.current_tel != '' && student.current_tel != null && student.current_tel != undefined) {
        if (student.current_tel.includes(zerochar)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์" : this.current_erorrtxt + "/Mobile Phone";
        }
        if (!this.validPhone()) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/โทรศัพท์เป็นตัวเลขเท่านั้น " : this.current_erorrtxt + "/Phone Number :";
        }
      }
      if (student.current_email == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/อีเมล์" : this.current_erorrtxt + "/Email";
      }
      if (student.current_email != '' && student.current_email != null && student.current_email != undefined) {
        if (this.validEmail(student.current_email) == false) {
          // console.log("email=",this.validEmail(student.current_email))
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ตรวจสอบอีเมล์" : this.current_erorrtxt + "/Valid email required";
        } else {
          var email_length = this.current_email.length;
          // console.log("email_length==",email_length);
          var new_email = this.current_email.substring(email_length - 2, email_length);
          // console.log("new_email==",new_email);
          if (new_email == 'co') {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/co กรอกไม่ครบ" : this.current_erorrtxt + "/Valid email required";
          }
        }
      }
      if ((student.current_country == 0) || (student.current_country == null) || (student.current_country == '')) {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ประเทศ" : this.current_erorrtxt + "/Country";
      }

      if (student.current_country == 'TH') {
        if (student.current_moo == "") {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/หมู่" : this.current_erorrtxt + "/Moo";
        }
        if ((student.current_provinceid == "")) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/จังหวัด" : this.current_erorrtxt + "/Province";
        }
        if ((student.current_district == "") || (student.current_district == 0) || (student.current_district == null)) {

          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/อำเภอ" : this.current_erorrtxt + "/District";
        }
        if ((student.current_subdistrict == "") || (student.current_subdistrict == 0) || (student.current_subdistrict == null)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ตำบล" : this.current_erorrtxt + "/Subdistrict";
        }
      } else {
        if ((student.current_province_name == "") || (student.current_province_name == null) || (student.current_province_name == undefined)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/จังหวัด" : this.current_erorrtxt + "/Province หห";
        }
        if ((student.current_district_name == "") || (student.current_district_name == null) || (student.current_district_name == undefined)) {

          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/อำเภอ" : this.current_erorrtxt + "/District";
        }
        if ((student.current_subdistrict_name == "") || (student.current_subdistrict_name == null) || (student.current_subdistrict_name == undefined)) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ตำบล" : this.current_erorrtxt + "/Subdistrict";
        }
      }
      if (student.current_no == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/เลขที่" : this.current_erorrtxt + "/Number";
      }
      if (student.current_no != '' && student.current_no != null && student.current_no != undefined) {
        if (student.current_no.length > 50) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/เลขที่ไม่เกิน 50 อักขระ" : this.current_erorrtxt + "/Valid Number";
        }
      }
      var bracket_open = "(";
      var bracket_close = ")";
      var square = "#";
      var star = "*";

      if (this.current_no != null && this.current_no != "" && this.current_no != undefined) {
        if ((this.current_no > 1) || (this.current_no < 9999999)) {
          // return true;
        } else if (this.current_no == "-") {
          // return true;
        } else {
          if (this.current_no.toString().length == 0) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/กรอกเลขที่เท่านั้น" : this.current_erorrtxt + "/Valid Number";
          } else {
            if (this.current_no.includes(bracket_open) || this.current_no.includes(bracket_close)
              || this.current_no.includes(square) || this.current_no.includes(star)) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/กรอกเลขที่เท่านั้น" : this.current_erorrtxt + "/Valid Number";
            } else if (this.current_no.includes('/') || this.current_no.includes('-')) {
              // return true;
            }

          }
        }

      } else {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/กรอกเลขที่เท่านั้น" : this.current_erorrtxt + "/Valid Number";
      }
      if (student.current_moo != '' && student.current_moo != null && student.current_moo != undefined) {
        if (student.current_moo.length > 50) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/หมู่ไม่เกิน 50 อักขระ" : this.current_erorrtxt + "/Valid Moo";
        }
      }
      if (student.current_village != '' && student.current_village != null && student.current_village != undefined) {
        if (student.current_village.length > 50) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/หมู่บ้านไม่เกิน 50 อักขระ" : this.current_erorrtxt + "/Valid Village";
        }
      }
      if (student.current_village == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/หมู่บ้าน" : this.current_erorrtxt + "/Village";
      }
      if (student.current_building != '' && student.current_building != null && student.current_building != undefined) {
        if (student.current_building.length > 50) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/อาคารไม่เกิน 50 อักขระ" : this.current_erorrtxt + "/Valid Building";
        }
      }
      if (student.current_building == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/อาคาร" : this.current_erorrtxt + "/Building";
      }
      if (student.current_lane != '' && student.current_lane != null && student.current_lane != undefined) {
        if (student.current_lane.length > 50) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ซอยไม่เกิน 50 อักขระ" : this.current_erorrtxt + "/Valid Soi";
        }
      }
      if (student.current_lane == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ซอย" : this.current_erorrtxt + "/Soi";
      }
      if (student.current_road != '' && student.current_road != null && student.current_lane != current_road) {
        if (student.current_road.length > 50) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ถนนไม่เกิน 50 อักขระ" : this.current_erorrtxt + "/Valid Street";
        }
      }
      if (student.current_road == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/ถนน" : this.current_erorrtxt + "/Street";
      }

      if (student.current_thai_student == 1) { // นศ ไทย
        if (student.current_spell_name != "" && student.current_spell_name != null && student.current_spell_name != undefined) {
          // if (this.current_spell_name.includes(substringnull)){
          //   this.numEror = this.numEror + 1;
          //   this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/กรุณา ใส่ - แทน เว้นวรรค": this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
          // }
          if ((student.current_spell_name.length >= 4) && (!this.current_spell_name.includes(substring))) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/คำอ่านชื่อ กรุณา ใส่ - แทน เว้นวรรค" : this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
          }
          if (student.current_spell_name.length > 300) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/สะกดชื่อไม่เกิน 300 อักขระ" : this.current_erorrtxt + "/Valid Spell";
          }
          if (student.current_spell_surname.length > 300) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/สะกดนามสกุลไม่เกิน 300 อักขระ" : "";
          }
        }
        if (student.current_spell_name == "") {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/สะกดชื่อ" : this.current_erorrtxt + "/Spell";
        } else {
          if (student.current_spell_name != "" && student.current_spell_name != null && student.current_spell_name != undefined) {
            if (student.current_spell_name.includes(substringnull)) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/คำอ่านชื่อ กรุณา ใส่ - แทน เว้นวรรค" : this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
            }
          }
        }
        if (student.current_spell_surname != "" && student.current_spell_surname != null && student.current_spell_surname != undefined) {
          if ((student.current_spell_surname.length >= 4) && (!student.current_spell_surname.includes(substring))) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/คำอ่านนามสกุล กรุณา ใส่ - แทน เว้นวรรค" : this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
          }
          if (student.current_spell_surname == "") {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/สะกดนามสกุล" : "";
          } else {
            if (student.current_spell_surname.includes(substringnull)) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/คำอ่านนามสกุล กรุณา ใส่ - แทน เว้นวรรค" : this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
            }
          }
        }
      } else { // นศ ต่างชาติ
        if (student.current_spell_name != "" && student.current_spell_name != null && student.current_spell_name != undefined) {
          if ((student.current_spell_name.length >= 4) && (student.current_spell_name.includes(substringnull))) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/คำอ่านชื่อ กรุณา ใส่ - แทน เว้นวรรค" : this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
          }
          if (student.current_spell_name.length > 300) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/สะกดชื่อไม่เกิน 100 อักขระ" : this.current_erorrtxt + "/Valid Spell";
          }
          if (student.current_spell_name == "") {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = student.current_thai_student == "1" ? this.current_erorrtxt + "/สะกดชื่อ" : this.current_erorrtxt + "/Spell";
          } else {
            if (student.current_spell_name.includes(substringnull)) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/คำอ่านชื่อ กรุณา ใส่ - แทน เว้นวรรค" : this.current_erorrtxt + "/Please use - (dash) to break up your name syllabically.";
            }
          }
        }
      }
      // console.log("------current_erorrtxt------", this.current_erorrtxt);
      // console.log("------numEror------", this.numEror);
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error = this.numEror;
      // return this.numEror;
      return student;
    },
    getCountry(thaistudent) {
      api
        .getCountryAll(thaistudent)
        .then(res => {
          this.countryItems = res.data.data;
          // console.log("ปท==", res.data.data);
        })
        .catch(err => {
          console.log("getCountry", err.toString());
        });
    },
    getProvince(thaistudent) {
      api
        .getProvinceAll(thaistudent)
        .then(res => {
          this.provinceItems = res.data.data;
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    selectProvinceOnchange: function () {
      this.onloadDistrictById(this.select_province);
      this.select_subdistrict = 0;
    },
    selectDistrictOnchange: function () {
      this.current_district = this.select_district;
      this.onloadSubDistrictById(this.select_district);
    },
    selectSubDistrictOnchange: function () {
      this.onloadZipcodeById(this.select_subdistrict);
    },
    getCountryId(id, thaistudent) {
      // console.log("id",id)
      api
        .getCountryById(id, thaistudent)
        .then(res => {
          this.current_country_name = res.data.data[0].COUNTRYNAME;
          // console.log("---current_country_name------", this.current_country_name);
        })
        .catch(err => {
          console.log("2 getCountryById", err.toString());
        });
    },
    selectCountryOnchange: function (e) {
      // console.log("selectCountryOnchange==", e);
      this.select_country = e.COUNTRYID
      this.current_country_name = e.COUNTRYNAME

      //this.getCountryId(this.select_country, this.thai_student);
    },
    onloadDistrictById() {
      // console.log("select_province", this.select_province);
      api
        .getDistrictByid(this.select_province, this.thai_student)
        .then(res => {
          // console.log("---getDistrictByid------", res);
          this.districtItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadDistrictById", err.toString());
        });
    },
    onloadSubDistrictById: async function () {
      api
        .getSubDistrictByid(this.select_district, this.thai_student)
        .then(res => {
          this.subdistrictItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadSubDistrictById", err.toString());
        });
    },
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.thai_student)
        .then(res => {
          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
        })
        .catch(err => {
          console.log("onloadZipcodeById", err.toString());
        });
    },
    nextPart() {
      this.$router.push('/part1');
    },
    onCreateData(student) {
      // console.log("postStudentGeneral==", student);
      api
        .postStudentGeneral(student)
        .then(res => {
          // console.log("res==", res);
          this.message = res.message;
          // console.log("insert ผ่าน", this.studentId);
          this.nextPart();

        }).catch(err => {
        console.log("onCreateData", err.toString());
        this.$router.push("logout");
      });

    },
    onUpdateData(student) {
      api
        .updateStudentGeneral(student)
        .then(res => {
          // console.log("student==",student);
          // console.log(res);
          if (res.data.code == 200) {
            this.message = res.message;
            // console.log("Update ผ่าน", this.studentId);
            this.nextPart();
          }

        }).catch(err => {
        console.log("onUpdateData", err.toString());
        // this.$router.push("Logout");
      });

    },
    onReset() {
      this.current_spell_name = "";
      this.current_spell_surname = "";
      this.current_tel = "";
      this.current_email = "";
      this.current_country = "";
      this.select_province = "";
      this.select_district = "";
      this.select_subdistrict = "";
      this.current_zipcode = "";
      this.current_address = "";
      this.current_no = "";
      this.current_moo = "";
      this.current_village = "";
      this.current_building = "";
      this.current_lane = "";
      this.current_road = "";
    },
    onSubmit() {
      var student = {};
      this.numEror = 0;
      var action_update = true;
      student = this.setStudent();
      var s = this.getErrorTxt(student);
      if (s.num_error == 0) {
        if (this.actionUpdate == 0) {
          // console.log("onCreateData==", s)
          this.onCreateData(s);
        } else if (this.actionUpdate == 1) {
          // console.log("onUpdateData==", s)
          this.onUpdateData(s);
        }
      }
    },
    toggleTimer() {
      var interval = setInterval(this.incrementTime, 1000);
      if (this.isRunning) {
        //debugger
        clearInterval(interval);
        // console.log('timer stops');
      } else {
        // console.log('timer starts');
      }
      this.isRunning = (this.isRunning ? false : true);
    },
    incrementTime() {
      // this.time = parseInt(this.time) + 1;
      // console.log(this.time)

      var decodedString = atob(this.$store.state.token.split(".")[1]);
      var obj = JSON.parse(decodedString);

      var timeout = obj.exp - new Date().getTime() / 1000

      var sec_num = parseInt(timeout, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      this.time = hours + ':' + minutes + ':' + seconds;

    },
  },
  created() {
    // console.log("x==",this.$store.state.user.thaistudent)

    if (this.$store.state.token == null || this.$store.state.user == null || this.$store.state.user == undefined || this.$store.state.user == '') {
      this.$router.push("/logout");
    } else {
      if ((this.$store.state.user != null) && (this.$store.state.user != undefined) && (this.$store.state.user != '')) {
        api.onSetHeader();
        this.actionUpdate = this.getCurrentStudent(this.$store.state.user.studentid);
        this.thai_student = this.$store.state.user.thaistudent;
        this.getLabelName(this.$store.state.user.thaistudent);

        this.getStudentID();
      }
      // this.toggleTimer();
    }
    // if (this.$store.state.user != null) {
    //
    // }
  }
}
;
</script>
<style>
</style>
